import { call, put, takeLatest, takeEvery } from "redux-saga/effects";

import {
  // fetch
  FETCH_DIVISION_LIST,
  FETCH_DIVISION_LIST_START,
  FETCH_DIVISION_LIST_SUCCESS,
  FETCH_DIVISION_LIST_FAIL,
  // add
  ADD_DIVISION,
  ADD_DIVISION_START,
  ADD_DIVISION_FAIL,
  ADD_DIVISION_SUCCESS,
  // update
  UPDATE_DIVISION,
  UPDATE_DIVISION_START,
  UPDATE_DIVISION_FAIL,
  UPDATE_DIVISION_SUCCESS,
  // delete
  DELETE_DIVISION,
  DELETE_DIVISION_START,
  DELETE_DIVISION_FAIL,
  DELETE_DIVISION_SUCCESS,
  // details
  FETCH_DIVISION_DETAILS,
  FETCH_DIVISION_DETAILS_START,
  FETCH_DIVISION_DETAILS_SUCCESS,
  FETCH_DIVISION_DETAILS_FAIL,
} from "../reducers/divisions/actions";

import * as divisionApi from "@/api/division";

function* fetchDivisionDetails({ meta, payload }) {
  try {
    yield put({ type: FETCH_DIVISION_DETAILS_START });
    const records = yield call(divisionApi.fetchRecord, payload);
    yield put({ type: FETCH_DIVISION_DETAILS_SUCCESS, payload: records, meta });
  } catch (err) {
    yield put({ type: FETCH_DIVISION_DETAILS_FAIL, payload: err, error: true, meta });
  }
}

function* fetchDivisionList({ meta }) {
  try {
    yield put({ type: FETCH_DIVISION_LIST_START });
    const records = yield call(divisionApi.fetchRecords);
    yield put({ type: FETCH_DIVISION_LIST_SUCCESS, payload: records, meta });
  } catch (err) {
    yield put({ type: FETCH_DIVISION_LIST_FAIL, payload: err, error: true, meta });
  }
}

function* addDivision({ meta, payload }) {
  try {
    yield put({ type: ADD_DIVISION_START });
    const record = yield call(divisionApi.insertRecord, payload);
    yield put({ type: ADD_DIVISION_SUCCESS, payload: record, meta });
    yield put({ type: FETCH_DIVISION_LIST, meta: { thunk: true } });
  } catch (err) {
    yield put({ type: ADD_DIVISION_FAIL, payload: err, error: true, meta });
  }
}

function* updateDivision({ meta, payload }) {
  try {
    yield put({ type: UPDATE_DIVISION_START });
    const record = yield call(divisionApi.updateRecord, payload.id, payload);
    yield put({ type: UPDATE_DIVISION_SUCCESS, payload: record, meta });
    yield put({ type: FETCH_DIVISION_LIST, meta: { thunk: true } });
  } catch (err) {
    yield put({ type: UPDATE_DIVISION_FAIL, payload: err, error: true, meta });
  }
}

function* deleteDivision({ meta, payload }) {
  try {
    yield put({ type: DELETE_DIVISION_START });
    const record = yield call(divisionApi.deleteRecord, payload);
    yield put({ type: DELETE_DIVISION_SUCCESS, payload: record });
    yield put({ type: FETCH_DIVISION_LIST, meta: { thunk: true } });
  } catch (err) {
    yield put({ type: DELETE_DIVISION_FAIL, payload: err, error: true, meta });
  }
}

export default function* divisionsSaga() {
  yield takeLatest(FETCH_DIVISION_DETAILS, fetchDivisionDetails);
  yield takeLatest(FETCH_DIVISION_LIST, fetchDivisionList);
  yield takeEvery(ADD_DIVISION, addDivision);
  yield takeEvery(UPDATE_DIVISION, updateDivision);
  yield takeEvery(DELETE_DIVISION, deleteDivision);
}
